const LOCATION_ROUTE = '^/locations/[^/]+';

// Sub-routes that keep the sidebar but drop the top bar.
const pathnameWithoutTopBar = ['schedule', 'timings', 'calendar'];

// Sub-routes that render as their own full-screen surface, with no app chrome
// at all. Keep in sync with routesForOwnerOperator in src/routes.tsx.
const pathnameFullScreen = ['details/[^/]+/menu-board-modification'];

const matchesLocationSubRoute = (pathname: string, patterns: string[]) =>
  new RegExp(`${LOCATION_ROUTE}/(${patterns.join('|')})(/|$)`).test(pathname);

export const isFullScreenPath = (pathname: string) =>
  matchesLocationSubRoute(pathname, pathnameFullScreen);

export const isTopBarHiddenPath = (pathname: string) =>
  isFullScreenPath(pathname) ||
  matchesLocationSubRoute(pathname, pathnameWithoutTopBar);
